import { useTranslation } from '../i18n';
import React from 'react';
import { Tag } from 'antd';

/**
 * 订阅状态标签（统一数据源）
 *
 * 覆盖后端全部订阅状态（含 processing / terminated），颜色/文案在
 * admin 与 user 两端保持一致，避免终止订阅在列表里渲染成原始英文文本。
 */
export const SUBSCRIPTION_STATUS_MAP = {
    pending: { color: 'default', text: '待激活' },
    processing: { color: 'processing', text: '处理中' },
    active: { color: 'success', text: '活跃' },
    suspended: { color: 'warning', text: '已暂停' },
    cancelled: { color: 'error', text: '已取消' },
    expired: { color: 'default', text: '已过期' },
    terminated: { color: 'error', text: '已终止' },
};

const SubscriptionStatusTag = ({ status }) => {
    const { t } = useTranslation();
    const config = SUBSCRIPTION_STATUS_MAP[status] || { color: 'default', text: status };
    return <Tag color={config.color}>{t(config.text)}</Tag>;
};

export default SubscriptionStatusTag;
